var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "step-progress" },
    _vm._l(_vm.steps, function (step, index) {
      return _c(
        "div",
        {
          key: step.id,
          class: [
            step.id < _vm.currentStepId ? "step-progress__step--past" : "",
            step.id == _vm.currentStepId ? "step-progress__step--active" : "",
            "step-progress__step",
          ],
        },
        [
          _c("span", { staticClass: "step-progress__step-index" }, [
            _vm._v(_vm._s(step.id)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "step-progress__step-label" }, [
            _vm._v(_vm._s(step.label)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }